<template>
    <!-- No reference in the address: nothing to show but a pointer to the search. -->
    <content-layout v-if="!$route.params.locationRef">
        <template #header>Locations</template>
        <div class="empty-state">
            <i class="el-icon-search"></i>
            <h2>Find a location</h2>
            <p>Search by location reference in the bar at the top of the page.</p>
        </div>
    </content-layout>

    <content-layout v-else-if="activeLocation">
        <template #header>
            {{ activeLocation.locationReference }}<span v-if="activeLocation.locationTitle" class="location-title"> · {{ activeLocation.locationTitle }}</span>
        </template>
        <template v-if="activeLocation.locationName || activeLocation.postcode" #description>
            {{ [activeLocation.locationName, activeLocation.postcode].filter(Boolean).join(', ') }}
        </template>
        <template #header-right>
            <el-button v-if="backToSearchButton" @click="backToSearch()" icon="el-icon-back" size="small">Back to Search</el-button>
            <!-- Status applies to the whole location, so it sits here rather than on each tab. -->
            <el-radio-group v-model="activeLocation.status" size="small" @change="statusChange">
                <el-radio-button label="active">Active</el-radio-button>
                <el-radio-button label="inactive">Inactive</el-radio-button>
                <el-radio-button label="pending">Pending</el-radio-button>
            </el-radio-group>
        </template>

        <el-tabs class="location-tabs">
            <el-tab-pane label="Location Information">
                <location-information :location="activeLocation"></location-information>
            </el-tab-pane>

            <el-tab-pane label="Owner Information">
                <owner-information :location="activeLocation"></owner-information>
            </el-tab-pane>

            <el-tab-pane label="Attributes">
                <location-attributes :location="activeLocation"></location-attributes>
            </el-tab-pane>

            <el-tab-pane v-if="activeLocation.images.length > 0" label="Images">
                <location-images :location="activeLocation" ref="locationImages"></location-images>
            </el-tab-pane>

            <el-tab-pane label="Upload Images">
                <image-upload :location="activeLocation" @changed="updateLocationImages"
                              ref="locationImageUpload"></image-upload>
            </el-tab-pane>
        </el-tabs>
    </content-layout>

    <content-layout v-else>
        <template #header>{{ $route.params.locationRef }}</template>
        <div v-if="notFound" class="empty-state">
            <i class="el-icon-warning-outline"></i>
            <h2>Location not found</h2>
            <p>There's no location with the reference "{{ $route.params.locationRef }}".</p>
        </div>
        <div v-else v-loading="true" class="location-loading"></div>
    </content-layout>
</template>

<script>
    import * as queryString from 'query-string';

    export default {
        data() {
            return {

                loading: true,

                // Locations get filled before mount.
                locations: [],
                randomValue: 0,

                value: '',

                headers: {
                    Authorization: localStorage.getItem('Authorization')
                },

                activeLocation: '',

                backToSearchButton: false,
                notFound: false

            }
        },

        watch: {
            value: function (val) {
                this.$router.push({
                    path: 'locations/' + val
                });
            },

        },

        methods: {

            backToSearch() {
                this.$router.push('/' + '?' + queryString.stringify(this.$route.query));
            },

            getLocation(cb = null) {
                this.axios.get(`${process.env.VUE_APP_ROOT_API}/api/locations/findbyref/${this.$route.params.locationRef}`, {headers: this.headers})
                    .then(response => {
                        console.log(response);
                        this.activeLocation = response.data;
                        if(cb){
                            cb();
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.notFound = true;
                    });
            },

            statusChange() {
                this.axios.patch(`${process.env.VUE_APP_ROOT_API}/api/locations/${this.activeLocation._id}`,
                    this.activeLocation,
                    {
                        headers: {
                            Authorization: localStorage.getItem('Authorization')
                        }
                    })
                    .then(response => {

                        console.log(response.data);

                        this.$notify({
                            title: 'Success',
                            message: 'Location Status Updated.',
                            type: 'success'
                        });


                    })
                    .catch(error => {
                        console.log(error);

                    });
            },

            goToLocation(locationReference) {

                this.$router.push('/locations/' + locationReference);
                // this.$router.go();

            },

            // This is used to notify the location images component to update the images.
            updateLocationImages() {


                this.getLocation(() => {
                    if (this.$refs.locationImages) {
                        this.$refs.locationImages.getImages();
                    }
                });


            },
        },


        beforeMount() {
            if (this.$route.params.locationRef) {
                this.getLocation();
            }

            // console.log('query', this.$route.query);
            if (this.$route.query.attributeSelectorType) {
                this.backToSearchButton = true;
            }

        },

    }
</script>

<style scoped>
    .location-title {
        color: var(--text-muted);
        font-weight: 400;
    }

    .location-tabs >>> .el-tabs__header {
        margin-bottom: 24px;
    }

    .location-loading {
        height: 240px;
    }
</style>



// WEBPACK FOOTER //
// src/locations/Locations.vue